export default __webpack_public_path__ + "static/media/9956fe43aaf17bb800b64730987b19d51582313725389.1fbefda2.webp";